import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import tr from 'locale';
import { Button } from '@3divi/baseui';
import ModalComponent from '../ModalComponent';
import { deactivateWorkspaceAction } from '../../../store/licenseInfo/actions';
import { useDispatch } from 'react-redux';
import { useIsMounted } from '../../../hooks/useIsMounted';

const StyledModal = styled(ModalComponent)`
  text-align: center;
`;

function NuitrackAnalyticsPausing(props) {
  const { hideAction, license } = props;

  const isMounted = useIsMounted();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const ref = useRef(null);

  useEffect(() => {
    ref.current && ref.current.focus();
  }, [ref]);

  const pauseLicense = async () => {
    try {
      setLoading(true);
      await dispatch(deactivateWorkspaceAction(license));
      if (isMounted.current) {
        setLoading(false);
        hideAction();
      }
    } catch {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };

  return (
    <StyledModal
      {...props}
      title={tr('pause')}
      subtitle={tr('license_manage_subtitle_na_subscribe')}
      text={tr('nuitrack-anayltics_status_manage_pause')}
      icon="warning"
      iconColor="hsla(56,80%,64%,1)"
      fixed={440}
      buttons={
        <>
          <Button
            innerRef={ref}
            size="m"
            elastic
            variant="contained"
            color="primary"
            text={tr('button_pause_license', { licenseName: tr('nuitrack-analytics-name') })}
            loading={loading}
            onClick={pauseLicense}
          />
          <Button
            autoFocus={true}
            size="m"
            elastic
            text={tr('button_cancel')}
            onClick={hideAction}
          />
        </>
      }
    />
  );
}

export default NuitrackAnalyticsPausing;
